export const parseBounds = (id: string) => {
  if (id.includes('-')) {
    const [lower, upper] = id.split('-').map(Number);
    return {lowerBound: lower, upperBound: upper};
  }
  return {lowerBound: Number(id), upperBound: null};
};
